const StepTypeLabels: Record<string, string> = {
    input: 'Data Input',
    inputCycle: 'Input Cycle',
    review: 'Review & Merge',
    approve: 'Review & Approve',
    arbitrate: 'Arbitrate & Combine',
    correct: 'Correct Data',
    correctCycle: 'Correction Cycle',

}

export default StepTypeLabels
